import { addMinutes, format, startOfToday } from "../../../date-fns/index.js";
function formatTime(value, timeFormat) {
  const start = startOfToday();
  return format(addMinutes(start, value), timeFormat);
}
export {
  formatTime
};
//# sourceMappingURL=formatTime.js.map
